<script>
  import { onMount } from 'svelte';
  import Masonry from 'masonry-layout';
  import imagesLoaded from 'imagesloaded';

  let masonryGrid;

  onMount(() => {
    const masonry = new Masonry(masonryGrid, {
      itemSelector: '.grid-item',
      columnWidth: '.grid-item',
      gutter: 0,
      percentPosition: true
    });

    imagesLoaded(masonryGrid, function() {
      masonry.layout();
    });

    return () => {
      masonry.destroy();
    };
  });
</script>

<div bind:this={masonryGrid} class="masonry-grid">
    <a href="https://elixir.ut.ee/minsepie/" class="grid-item minsepie">
        <img src="/images/minsepie.png" alt="MinsePIE" />
        <div class="item-content">
            <h3>MinsePIE</h3>
            <p>Prediction of prime editing</p>
        </div>
    </a>
    <a href="https://elixir.ut.ee/forecast-be/" class="grid-item be">
        <img src="/images/be.png" alt="BE" />
        <div class="item-content">
            <h3>FORECasT-BE</h3>
            <p>Prediction of base editing</p>
        </div>
    </a>
    <a href="https://elixir.ut.ee/forecast/" class="grid-item forecast">
        <img src="/images/forecast.png" alt="Forecast" />
        <div class="item-content">
            <h3>FORECasT</h3>
            <p>CRISPR/Cas9 cut predictions</p>
        </div>
    </a>
    <a href="https://elixir.ut.ee/forecast-repair/" class="grid-item repair">
        <img src="/images/repair.png" alt="Repair" />
        <div class="item-content">
            <h3>FORECasT-repair</h3>
            <p>CRISPR/Cas9 cut predictions</p>
        </div>
    </a>
</div>


<style>
    .masonry-grid {
        margin: 0 auto;
        max-width: 1160px;
        padding: 50px;
        box-sizing: border-box;
    }
    .grid-item {
        width:  calc(50% - 50px);
        box-sizing: border-box;
        margin-bottom: 0;
        position: relative;
        overflow: hidden;
        display: block;
        color: white;
        text-decoration: none;
    }
    .grid-item img {
        width: 100%;
        height: auto;
        display: block;
        object-fit: cover;
        transition: transform 0.5s ease-in-out, opacity 0.3s ease-in-out;
    }

    .grid-item::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: inherit;
        opacity: 0.3;
        transition: opacity 0.3s ease-in-out;
        z-index: 1;
    }
    .grid-item:hover::after {
        opacity: 0.8;
    }
    .grid-item:hover img {
        transform: scale(1.2);
    }
    .item-content {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        background-color: rgba(10, 10, 10, 0.8);
        padding: 10px;
        box-sizing: border-box;
        z-index: 2;
    }
    .item-content h3 {
        margin: 0;
        font-family: 'Oswald', sans-serif;
        font-size: 1.5em;
        transition: color 0.5s ease-in-out;
    }

    .item-content p {
        font-family: 'Roboto', sans-serif;
        margin: 0;
    }

    .minsepie::after { background-color: coral; }
    .be::after { background-color: #6f84ef; }
    .repair::after { background-color: #ab4e73; }
    .forecast::after { background-color: #037070; }

    .minsepie .item-content h3 { color: rgba(255, 127, 80, 1); }
    .be .item-content h3 { color: rgba(111, 132, 239, 1); }
    .repair .item-content h3 { color: rgba(171, 78, 115, 1); }
    .forecast .item-content h3 { color: rgba(3, 112, 112, 1); }

    .grid-item:hover .item-content h3 {
        color: rgba(255, 255, 255, 0.9);
    }

    @media (max-width: 800px) {
        .masonry-grid {
            padding: 0px;
        }
        .grid-item {
            width: 100%;
        }
    }
</style>
